// Audio configuration matching backend: PCM 24kHz 16-bit mono
export const SAMPLE_RATE = 24000;
export const FRAME_SIZE_MS = 20;
export const BYTES_PER_FRAME = SAMPLE_RATE * (FRAME_SIZE_MS / 1000) * 2; // 960 bytes per 20ms frame

export const CALL_STATUS = {
  idle: 'idle',
  connecting: 'connecting',
  active: 'active',
  error: 'error',
} as const;
